export default {
    title: 'Dashboard',
    loading: 'Načítám…',
    refresh: 'Obnovit',
    updatedAgo: 'Aktualizováno před {seconds} s',
    error: 'Nepodařilo se načíst dashboard: {message}',
    noPermissions: 'Nemáte přiřazena žádná oprávnění. Požádejte administrátora.',
    kpi: {
        sectionLabel: 'Stav za 24 hodin',
        validations24h: 'Validací za 24 h',
        tickets: 'Vstupenky',
        devicesOnline: 'Aktivní zařízení',
        upcomingEvents: 'Akce ±7 dní',
        deltaUp: '↑ {percent} % vs. včera',
        deltaDown: '↓ {percent} % vs. včera',
        deltaFlat: 'beze změny'
    },
    events: {
        title: 'Aktivní akce',
        empty: 'Žádné akce v nejbližších 7 dnech',
        showAll: 'Zobrazit všechny →',
        progress: '{used} / {total} ({percent} %)',
        scanRate: '{count} validací za poslední hodinu'
    },
    feed: {
        title: 'Poslední scany',
        empty: 'Zatím žádné scany'
    },
    alerts: {
        title: 'Upozornění',
        deviceOffline: 'Zařízení {name} mlčí > 2 h',
        eventNoScans: 'Akce {name} startuje za < 24 h, 0 validací',
        brokenTicketset: 'Sada {name} bez ceny — nelze skenovat',
        unknown: 'Neznámé upozornění',
        empty: 'Vše v pořádku'
    },
    actions: {
        title: 'Rychlé akce',
        importTickets: 'Importovat vstupenky',
        newEvent: 'Nová událost',
        newDevice: 'Nové zařízení'
    },
    instances: {
        title: 'Přehled instancí',
        name: 'Instance',
        events: 'Aktivní akce',
        scans24h: 'Scany 24 h',
        devices: 'Zařízení'
    }
}
